import logger from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import createStore from './createStore';

import reducers from './ducks';
import sagas from './sagas';

const history = createBrowserHistory();

const middlewares = [];

if (process.env.NODE_ENV !== 'production') {
  // middlewares.push(logger);
}

const sagaMonitor = process.env.NODE_ENV === 'development' ? console.tron.createSagaMonitor() : null;

const sagaMiddleware = createSagaMiddleware({ sagaMonitor });

middlewares.push(sagaMiddleware);
middlewares.push(routerMiddleware(history));

const store = createStore(reducers(history), middlewares);

sagaMiddleware.run(sagas);

export default store;
export { history };
